/* eslint-disable */
import React, { useState, useEffect } from 'react'
import Shipping from './Shipping'
import AddShipping from './AddShipping'
import { getAllShippings } from '../../actions/shippingActions'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import NoData from '../svgIcons/NoData'
import Spinner from '../Spinner/Spinner'

const ShippingList = () => {
  const history = useHistory()
  const location = useLocation()
  const [openShipping, setOpenShipping] = useState(false)
  const [currentId, setCurrentId] = useState(null)
  const dispatch = useDispatch()
  const user = JSON.parse(localStorage.getItem('profile'))
  const { shippings } = useSelector((state) => state.shipping)
  const isLoading = useSelector((state) => state.shipping.isLoading)

  useEffect(() => {
    dispatch(getAllShippings())
  }, [location, dispatch])

  if (!user) {
    history.push('/login')
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          paddingTop: '20px',
        }}
      >
        <Spinner />
      </div>
    )
  }

  if (shippings.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          paddingTop: '20px',
          margin: '80px',
        }}
      >
        <NoData />
        <p style={{ padding: '40px', color: 'gray', textAlign: 'center' }}>
          No shipping records yet. Click the add button to add shipping.
        </p>
      </div>
    )
  }

  return (
    <div>
      <AddShipping
        openShipping={openShipping}
        setOpenShipping={setOpenShipping}
        currentId={currentId}
        setCurrentId={setCurrentId}
      />
      <Shipping
        openShipping={openShipping}
        setOpenShipping={setOpenShipping}
        currentId={currentId}
        setCurrentId={setCurrentId}
        shippings={shippings}
      />
    </div>
  )
}

export default ShippingList
